const ERC20_DECIMALS = 18;
export { ERC20_DECIMALS };
